module.exports = __webpack_public_path__ + "img/icon-6.8a802d4c.png";